import { render, staticRenderFns } from "./BlogArticleDetail.vue?vue&type=template&id=3bba5be9&scoped=true"
import script from "./BlogArticleDetail.vue?vue&type=script&lang=js"
export * from "./BlogArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./BlogArticleDetail.vue?vue&type=style&index=0&id=3bba5be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba5be9",
  null
  
)

export default component.exports